module.exports = __webpack_public_path__ + "resources/img/logo_partner_commerce_tasteshop.409b8e39a2f63f378e9b471ec9d62352.png";